import * as React from 'react'
function SvgViewEmpty(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M20 8c9.462 0 15.492 10.574 15.744 11.024a2 2 0 01-.002 1.96C35.488 21.432 29.414 32 20 32 10.538 32 4.508 21.426 4.256 20.978a1.997 1.997 0 01-.004-1.95C4.502 18.578 10.49 8 20 8zm0 4c-5.708 0-10.084 5.67-11.638 7.998C9.924 22.324 14.318 28 20 28c5.674 0 10.068-5.668 11.636-8-1.564-2.33-5.958-8-11.636-8zm0 4a4 4 0 110 8 4 4 0 010-8z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgViewEmpty
